import { SAVE_REQUESTED_TESTS } from "../constants/tickets";
import {TAG_SPLITTER_REGEX} from "../../components/tagInput";

const initialState = {
  requestedTests: []
};

function splitItemsAndRemoveEmpty(payload) {
  let requestedTests = [];
  for (const payloadElement of payload) {
    requestedTests = requestedTests.concat(payloadElement.split(TAG_SPLITTER_REGEX).filter(str =>!!str))
  }

  return requestedTests;
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_REQUESTED_TESTS:
      return {
        ...state,
        requestedTests : splitItemsAndRemoveEmpty(action.payload)
      };
    default:
      return state;
  }
}
